import { ActionTypes } from '../../constants/action-types';

export function requestItinerary() {
  return { type: ActionTypes.ITINERARY_GET_REQUEST };
}

export function requestItineraryChanges() {
  return { type: ActionTypes.ITINERARY_REQUEST_CHANGES_REQUEST };
}

export function combinationInit() {
  return { type: ActionTypes.COMBINATION_INIT };
}

export function setRecommandedCombination(data: { name: string, index: number }) {
  return {
    type: ActionTypes.UPDATE_SELECTEDCOMBINATIONS, data
  };
}

export function setRecommendedHotelItem(data: { id : number, landId: number, type0Id: number}) {
  return {
    type: ActionTypes.UPDATE_RECOMMENDED_HOTEL_ITEM, data
  };
}

export function setRecommendedCarItem(data: { id : number, landId: number, type0Id: number}) {
  return {
    type: ActionTypes.UPDATE_RECOMMENDED_CAR_ITEM, data
  };
}


